import type { PropsWithChildren } from "react";

import { Loading } from "./components/Loading";
import type { IButtonProps } from "./IButtonProps";

export const Button: React.FC<PropsWithChildren<IButtonProps>> = ({
	mode = "filled",
	color = "standard",
	loading,
	loadingMessage,
	className,
	children,
	...rest
}) => {
	return (
		<button
			disabled={loading}
			data-mode={mode}
			data-color={color}
			className={`flex shrink-0 h-10 whitespace-nowrap justify-center
        items-center px-2 gpa-xs:px-4 py-1 rounded-lg cursor-pointer
        disabled:cursor-not-allowed select-none font-semibold text-sm
        gpa-xs:text-base disabled:opacity-60 border-gpa-blue-500 border-2
        bg-white text-gpa-blue-500 enabled:active:bg-slate-50
        border-none transition-all duration-200
        data-[mode=blank]:bg-transparent
        hover:data-[mode=blank]:data-[color=error]:bg-gpa-red/5
        hover:data-[mode=blank]:bg-gpa-blue-400/5
        data-[mode=blank]:data-[color=error]:text-gpa-red
        data-[mode=filled]:bg-gpa-blue-500 data-[mode=filled]:text-white
        data-[mode=filled]:enabled:active:bg-[#1b5b9a]
        data-[mode=filled]:hover:bg-gpa-blue-600
        data-[mode=filled]:data-[color=error]:bg-gpa-red
        data-[mode=filled]:data-[color=error]:hover:bg-red-400
        data-[mode=filled]:data-[color=error]:enabled:active:bg-red-500
        data-[color=error]:border-gpa-red
        data-[mode=outlined]:data-[color=error]:text-gpa-red
        data-[mode=outlined]:ring-2 data-[mode=outlined]:ring-gpa-blue-500
        data-[mode=outlined]:data-[color=error]:ring-gpa-red
        ${className}`}
			{...rest}
		>
			{loading ? <Loading>{loadingMessage}</Loading> : children}
		</button>
	);
};
